import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMembershipsWithRules, StateStatus } from '@guryou/redux';

const useMembershipsWithRules = () => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(state => state.membership.membershipsWithRules);

  useEffect(() => {
    if (status === StateStatus.NOT_INITIALIZED) {
      dispatch(getMembershipsWithRules());
    }
  }, [dispatch, status]);

  return { data: data || [], status, version, entity };
};

export default useMembershipsWithRules;
